import React, { useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    // TableHead,
    TableRow,
    TableContainer,
    Stack,
    Switch,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from "@mui/material";
import StatusBadge from "components/StatusBadge/StatusBadge";

const CustomTable = ({
    data = [],
    columns = [],
    onViewDetails,
    onEditClick,
    onDeleteClick,
    onStatusToggle,
    onApprove,
    onReject,
}) => {
    // console.log("Data", data)
    // console.log("Columns", columns)
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleToggleClick = (row) => {
        setSelectedItem(row);
        setConfirmOpen(true);
    };

    const handleConfirm = async () => {
        if (!selectedItem) return;
        try {
            setLoading(true);
            await onStatusToggle(selectedItem);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
            setConfirmOpen(false);
            setSelectedItem(null);
        }
    };

    const handleCancel = () => {
        setConfirmOpen(false);
        setSelectedItem(null);
    };

    // const lastTransactionType =
    //     walletTransactionsHistory?.transactions?.[0]?.type;

    // const previousBalanceColor =
    //     lastTransactionType === "Credit"
    //         ? "#2e7d32" // green
    //         : lastTransactionType === "Debit"
    //             ? "#d32f2f" // red
    //             : "#6b7280"; // gray

    const getTransactionColor = (type) => {
        if (type === "Credit") return "#2e7d32"; // green
        if (type === "Debit") return "#d32f2f";  // red
        return "inherit";
    };

    return (
        <>
            <TableContainer>
                <Table>
                    <TableBody>
                        {/* <TableHead> */}
                        <TableRow>
                            {columns.map((col) => (
                                <TableCell key={col.key} sx={{ fontWeight: "bold", fontSize: "14px" }}>
                                    {col.label}
                                </TableCell>
                            ))}
                            {(onViewDetails || onEditClick || onDeleteClick || onStatusToggle || onApprove || onReject) && (
                                <TableCell sx={{ fontWeight: "bold", fontSize: "14px", textAlign: "center" }}>
                                    Actions
                                </TableCell>
                            )}
                        </TableRow>
                        {/* </TableHead> */}

                        {data.length > 0 ? (
                            data.map((row) => (
                                <TableRow key={row.id} hover>
                                    {columns.map((col) => (

                                        // <TableCell
                                        //     key={col.key}
                                        //     sx={{
                                        //         color:
                                        //             col.key === "type"
                                        //                 ? (row.type)
                                        //                 : col.key === "amount"
                                        //                     ? getTransactionColor(row.type)
                                        //                     : "inherit",
                                        //         fontWeight: col.key === "type" ? 600 : 400,
                                        //     }}
                                        // >
                                        //     {col.key === "status" && onStatusToggle ? (
                                        //         <Stack direction="row" alignItems="center" justifyContent="center">
                                        //             <Switch
                                        //                 checked={row.status === "active"}
                                        //                 onChange={() => handleToggleClick(row)}
                                        //                 color="success"
                                        //             />
                                        //         </Stack>
                                        //     ) : col.render ? (
                                        //         col.render(row[col.key], row)
                                        //     ) : (
                                        //         row[col.key] ?? "-"
                                        //     )}
                                        // </TableCell>
                                        <TableCell
                                            key={col.key}
                                            sx={{
                                                color:
                                                    col.key === "type"
                                                        ? row.type
                                                        : col.key === "amount"
                                                            ? getTransactionColor(row.type)
                                                            : "inherit",
                                                fontWeight: col.key === "type" ? 600 : 400,
                                                textAlign: col.key.toLowerCase().includes("status") ? "center" : "left",
                                            }}
                                        >
                                            {col.key.toLowerCase().includes("status") && !onStatusToggle ? (
                                                <StatusBadge status={col.render ? col.render(row[col.key], row) : row[col.key]} />
                                            ) : col.key === "status" && onStatusToggle ? (
                                                <Stack direction="row" alignItems="center" justifyContent="center">
                                                    <Switch
                                                        checked={row.status === "active"}
                                                        onChange={() => handleToggleClick(row)}
                                                        color="success"
                                                    />
                                                </Stack>
                                            ) : col.render ? (
                                                col.render(row[col.key], row)
                                            ) : (
                                                row[col.key] ?? "-"
                                            )}
                                        </TableCell>

                                    ))}

                                    {(onViewDetails || onEditClick || onDeleteClick || onStatusToggle || onApprove || onReject) && (
                                        <TableCell
                                            sx={{
                                                verticalAlign: "middle",
                                                textAlign: "center",
                                                minWidth: 180,
                                            }}
                                        >
                                            <Stack direction="row" spacing={1} justifyContent="center">
                                                {onApprove && (
                                                    <Button
                                                        size="small"
                                                        sx={{ color: "#2e7d32" }}
                                                        onClick={() => onApprove(row)}
                                                    >
                                                        Approve
                                                    </Button>
                                                )}
                                                {onReject && (
                                                    <Button
                                                        size="small"
                                                        sx={{ color: "#d32f2f" }}
                                                        onClick={() => onReject(row)}
                                                    >
                                                        Reject
                                                    </Button>
                                                )}
                                                {onViewDetails && (
                                                    <Button size="small" sx={{ color: "#36eb4eff" }} onClick={() => onViewDetails(row)}>
                                                        Details
                                                    </Button>
                                                )}
                                                {onEditClick && (
                                                    <Button
                                                        size="small"
                                                        sx={{ color: "#36eb4eff", "&:hover": { color: "#e68900" } }}
                                                        onClick={() => onEditClick(row)}
                                                    >
                                                        Edit
                                                    </Button>
                                                )}
                                                {onDeleteClick && (
                                                    <Button
                                                        size="small"
                                                        sx={{ color: "#7e7170ff", "&:hover": { color: "#d32f2f" } }}
                                                        onClick={() => onDeleteClick(row)}
                                                    >
                                                        Delete
                                                    </Button>
                                                )}
                                            </Stack>
                                        </TableCell>
                                    )}
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={columns.length + 1} align="center">
                                    No data found.
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Confirmation Dialog */}
            <Dialog open={confirmOpen} onClose={handleCancel}>
                <DialogTitle>Confirm Status Change</DialogTitle>
                <DialogContent>
                    <Typography>
                        Do you want to {selectedItem?.status === "active" ? "deactivate" : "activate"} this service?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancel} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleConfirm} color="primary" disabled={loading}>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default CustomTable;
